import { useMutation } from "react-query";
import * as department from "services/configuration/department/department";

export const useDepartmentList = () => {
  return useMutation((formData) => department.departmentList(formData));
};

export const useAddDepartment = () => {
  return useMutation((formData) => department.addDepartment(formData));
};

export const useEditDepartment = () => {
  return useMutation((formData) => department.editDepartment(formData));
};

export const useDeleteDepartment = () => {
  return useMutation((id) => department.deleteDepartment(id));
};
 export const useStatusDepartment = () => {
     return useMutation((formData) => department.changeStatus(formData));
   };
